import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'filtroNome',
    pure: false
})
export class FiltroNome implements PipeTransform {
    transform(items: any[], filter: string): any {
        if (!items || !filter) {
            return items;
        }
        if (items[0].nome) {
            return items.filter(item => item.nome.toLowerCase().indexOf(filter.toLowerCase()) !== -1);
        } else if (items[0].nomeInstalacao) {
            return items.filter(item => item.nomeInstalacao.toLowerCase().indexOf(filter.toLowerCase()) !== -1);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/artefato/filtro/filtro-nome.ts